import { render, staticRenderFns } from "./CobranzasPorAgenciaPage.vue?vue&type=template&id=283bd032&scoped=true"
import script from "./CobranzasPorAgenciaPage.vue?vue&type=script&lang=js"
export * from "./CobranzasPorAgenciaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283bd032",
  null
  
)

export default component.exports